import styled from 'styled-components'

const KATAKANA_COLOR = '#2aa290'
const HIRAGANA_COLOR = '#bf5ec8'

export const AppUI = styled('div')`
  display: flex;
  justify-content: space-around;
  min-height: 100vh;
  padding: 10px 0 50px;
  background-color: #e5e5f7;
  background-size: 10px 10px;
  background-image: repeating-linear-gradient(
    45deg,
    #b3b6f3 0,
    #b3b6f3 1px,
    #e5e5f7 0,
    #e5e5f7 50%
  );

  &.font-serif {
    .ColumnUI,
    .CardUI {
      font-family: Georgia, serif;
    }
  }

  &.font-sans-serif {
    .ColumnUI,
    .CardUI {
      font-family: 'Courier New', monospace;
    }
  }
`

export const PageUI = styled('div')`
  min-width: 275px;
  max-width: 700px;
  width: 100%;
  padding: 20px 0;
  background-color: rgba(255, 255, 255, 0.85);
  position: relative;

  h1 {
    margin: 0 0 20px 0;
    padding: 0;
    font-size: 20px;
    text-align: center;
  }

  .is-hiragana {
    color: ${HIRAGANA_COLOR};
  }

  .is-katakana {
    color: ${KATAKANA_COLOR};
  }

  &.page-kana,
  &.page-romaji {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  input[type='text'] {
    margin-bottom: 20px;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    border: 0;
    box-shadow: inset 3px 3px 0 #cecece, 0 0 0 2px #494952;
    background-color: #f5f5f5;
    border-radius: 3px;
    width: 50px;
  }

  input[type='radio'] {
    height: 18px;
    width: 18px;
    margin: 0 5px 0 0;
  }

  .info {
    font-size: 13px;
    margin-bottom: 4px;
  }

  .select-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 10px 0;
    justify-content: space-around;

    button {
      margin-bottom: 10px;
    }
  }

  .go-back {
    width: 170px;
    font-size: 14px;
    padding: 15px;
  }

  .next-one {
    display: block;
    margin-bottom: 15px;
  }

  .info-box {
    margin-bottom: 15px;
    text-align: center;
  }

  .notice {
    padding: 30px;
    text-align: center;

    button {
      display: block;
      margin: 50px auto;
    }
  }
`

export const TabsUI = styled('div')`
  display: flex;
  width: 300px;
`

export const TabUI = styled('button')`
  position: relative;
  border: 0;
  height: 40px;
  width: 150px;
  border-bottom: 0;
  background-color: #e5e5f7;
  font-size: 14px;

  &.is-active {
    font-weight: 800;
    color: white;
  }

  &.hiragana-tab.is-active {
    background-color: ${HIRAGANA_COLOR};
  }

  &.katakana-tab.is-active {
    background-color: ${KATAKANA_COLOR};
  }

  &.found::after {
    content: '';
    display: block;
    position: absolute;
    top: 5px;
    right: 5px;
    width: 0;
    height: 0;
    border-top: 4px solid #38065c;
    border-bottom: 4px solid transparent;
    border-right: 4px solid #38065c;
    border-left: 4px solid transparent;
    z-index: 99;
  }
`

export const SetsContainerUI = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fill, 40px);
  grid-gap: 5px;
  justify-content: space-between;
  padding: 10px 4px 0 4px;

  &.is-hiragana-active-tab {
    background-color: ${HIRAGANA_COLOR};
  }
  &.is-katakana-active-tab {
    background-color: ${KATAKANA_COLOR};
  }
`

export const ColumnUI = styled('label')`
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.is-checked {
    background-color: lightskyblue;
    box-shadow: 0 0 0 2px dodgerblue;
  }

  input {
    margin: 0 0 10px 0;
    padding: 0;
  }
`

export const KanaSetUI = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;

  div {
    margin-bottom: 5px;
  }
`

export const OptionsUI = styled('div')`
  font-size: 14px;
  width: 250px;
  margin: 0 auto 15px;

  label {
    width: 100px;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
    display: inline-flex;
    align-items: center;
  }

  div {
    font-weight: 600;
    margin-bottom: 5px;
  }
`

export const ButtonUI = styled('button')`
  background-color: #444cf7;
  color: white;
  border: 0;
  border-radius: 3px;
  padding: 10px 25px;
  font-size: 18px;

  &.lets-practice {
    width: 98%;
    margin: 0 auto;
    display: block;
  }

  &.timer-control {
    margin-bottom: 20px;
  }

  &.restart {
    width: 90%;
    margin: 20px auto;
    display: block;
    background-color: #67b161;
  }

  &.all-hiragana {
    background-color: ${HIRAGANA_COLOR};
  }

  &.all-katakana {
    background-color: ${KATAKANA_COLOR};
  }
`

export const AnswerButtonUI = styled('button')`
  border: 0;
  border-radius: 3px;
  padding: 5px 15px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 25px;
  color: white;
  width: 120px;
  height: 50px;
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;

  &.right {
    background-color: #61b191;
    margin-right: 15px;
  }

  &.wrong {
    background-color: #d94076;
  }
`

export const CardUI = styled('button')`
  display: block;
  background-color: #fff;
  border: 0;
  padding: 0;
  margin: 0;
  width: 200px;
  height: 150px;
  border-radius: 5px;
  text-align: center;
  box-shadow: 0 0 0 4px #e5e5f7, 0 0 0 6px #444cf7;
  font-size: 100px;
  line-height: 150px;
  margin-bottom: 20px;
  color: black;

  &.is-hiragana {
    color: ${HIRAGANA_COLOR};
  }

  &.is-katakana {
    color: ${KATAKANA_COLOR};
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0 0 0 4px #e5e5f7, 0 0 0 6px #444cf7,
      0 0 8px 8px rgba(119, 123, 127, 0.35);
  }

  &.answered-wrong {
    box-shadow: 0 0 0 2px lightcoral;
  }
`
